<template>
    <div class="p_30 b_b full_h">
    <div class="helpTitle font24">
      {{helpDetail.question}}
      <span @click="$router.back()" class="font12 colorGray959595" style="float: right;margin-top: 12px">返回</span>
    </div>
    <img src="../../../../assets/borderImg.png" style="width: 100%" alt="">
    <div class="m_t_20 o_a" style="height: calc(100% - 140px);color: #66667f">
      <div v-html="helpDetail.answer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['choosenSubItem'],
  data () {
    return {
      helpDetail: {}
    }
  },
  created () {
    document.title = '百钢一下 | 钢铁电商，百炼成钢'
    this.$axiox
      .post(
        `/baigang/shop/question/queryDetail/${this.$route.query.id}`,
        {}
      )
      .then((p) => {
        this.helpDetail = p.data.find(p => {
          return parseInt(p.id) === parseInt(this.$route.query.subId)
        })
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/page/help/helpDetail.vue